<script setup lang="ts">
import type { ICopilotMissingFields } from "~/utils/interfaces/copilot-blocks-interfaces";

defineProps<{
  missingFields: ICopilotMissingFields;
}>();
</script>

<template>
  <div class="flex flex-col gap-3">
    <span v-if="missingFields.intro" class="body_regular text-primary-color">{{ missingFields.intro }}</span>

    <ol class="flex flex-col gap-2">
      <li v-for="(item, index) of missingFields.items" :key="index" class="flex items-start gap-2">
        <span
          class="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary-blue-color text-light-color meta"
        >
          {{ index + 1 }}
        </span>
        <span class="body_regular text-primary-color">{{ item }}</span>
      </li>
    </ol>
  </div>
</template>
